import { render, staticRenderFns } from "./simulacao-seguro-multirriscos.html?vue&type=template&id=4c41c1a6&scoped=true&"
import script from "./simulacao-seguro-multirriscos.js?vue&type=script&lang=js&"
export * from "./simulacao-seguro-multirriscos.js?vue&type=script&lang=js&"
import style0 from "./simulacao-seguro-multirriscos.scss?vue&type=style&index=0&id=4c41c1a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c41c1a6",
  null
  
)

export default component.exports